export default "__VITE_ASSET__BJy1TfBT__"